/* TB V7.7 Leistung: ein gemeinsamer Takt für alle Timer (statt setInterval je Timer), Timer außerhalb des Bildschirms
   werden nicht neu geschrieben, und der DOM-Beobachter sucht neue Timer höchstens 1x pro Bild (vorher bei JEDER Änderung
   auf der Seite querySelectorAll über das ganze Dokument – Startseite ~1 s Hauptthread auf Mittelklasse-Handys). */
document.addEventListener('DOMContentLoaded', function () {
  var TIMERS = [], ticking = 0, seen = new WeakMap();
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) { es.forEach(function (e) { seen.set(e.target, e.isIntersecting); }); }, { rootMargin: '200px' }) : null;
  function tickAll() { for (var i = TIMERS.length - 1; i >= 0; i--) { if (TIMERS[i]() === false) TIMERS.splice(i, 1); } if (!TIMERS.length) { clearInterval(ticking); ticking = 0; } }
  function initializeTimer(endTime, timerId) {
    var second = 1000,
      minute = second * 60,
      hour = minute * 60,
      day = hour * 24;
    var countDown = new Date(endTime).getTime();

    function padNumber(number) {
      return Math.max(0, number).toString().padStart(2, '0');
    }

    function updateTimer() {
      var now = new Date().getTime(),
        distance = countDown - now;

      var timerElement = document.getElementById('timer-' + timerId);
      if (!timerElement) return false;

      if (distance < 0) {
        timerElement.remove();
        return false;
      }
      if (io && seen.get(timerElement) === false) return;

      // Set background color based on remaining time
      if (distance <= hour) {
        timerElement.style.backgroundColor = '#ca3231';
      } else if (distance <= 2 * hour) {
        timerElement.style.backgroundColor = '#ffa411';
      } else if (distance <= 3 * hour) {
        timerElement.style.backgroundColor = '#e9bb39';
      } else {
        timerElement.style.backgroundColor = '#4d8ea9'; // Default color
      }

      timerElement.querySelector('.js-timer-days').innerText = padNumber(Math.floor(distance / day));
      timerElement.querySelector('.js-timer-hours').innerText = padNumber(Math.floor((distance % day) / hour));
      timerElement.querySelector('.js-timer-minutes').innerText = padNumber(Math.floor((distance % hour) / minute));
      timerElement.querySelector('.js-timer-seconds').innerText = padNumber(Math.floor((distance % minute) / second));
    }

    var el0 = document.getElementById('timer-' + timerId);
    if (io && el0) io.observe(el0);
    TIMERS.push(updateTimer);
    if (!ticking) ticking = setInterval(tickAll, second);
    updateTimer();
  }

  function initializeAllTimers() {
    document.querySelectorAll('[data-timer-id]').forEach(function (element) {
      var timerId = element.getAttribute('data-timer-id');
      var endTime = element.getAttribute('data-end-time');
      if (!element.getAttribute('data-initialized')) {
        element.setAttribute('data-initialized', 'true');
        initializeTimer(endTime, timerId);
      }
    });
  }

  // Initialize all timers on page load
  initializeAllTimers();

  // Monitor for dynamically added timers using MutationObserver
  var moRaf = 0;
  var observer = new MutationObserver(function () {
    if (moRaf) return;
    moRaf = requestAnimationFrame(function () { moRaf = 0; initializeAllTimers(); });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});